import React, { useEffect, useState } from "react";
import DTOEmployeeTicketARModal from "./DTOEmployeeTicketARModal";
import EmployeeTicketARModalPresenter from "./EmployeeTicketARModalPresenter";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../infra/hooks";
import toast from "react-hot-toast";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
  historyData: any;
}

const EmployeeTicketARModalController = ({
  isModalOpen,
  closeModal,
  historyData,
  fullData,
}: ModalInterface) => {
  const [allActions, setAllActions] = useState([]);
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);

  const getActions = (act: any) => {
    setAllActions(act);
  };
  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };

  return (
    <div>
      <DTOEmployeeTicketARModal
        setAllActions={(act: any) => setAllActions(act)}
      />

      <EmployeeTicketARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        historyData={historyData}
        allActions={allActions}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default EmployeeTicketARModalController;
